import { BaseDOM } from "../domain/base.dom";

export class SimpleListModel extends BaseDOM<SimpleListModel> {
    idx?: number;
    s!: string;
}